import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Modal, Card, CardBody, Button, ModalBody, ModalFooter, Table, ModalHeader, Row, Col, Label, Input} from 'reactstrap';
import axios from 'axios';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import Select from 'react-select';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import moment from 'moment';
import {getAccounts} from '../../store/Accounts/actions';
import {getProductListActive} from '../../store/Products/actions';
import {savePurchase, getPendingPurchaseItems, getPurchaseList} from '../../store/Purchase/actions';
import {getCompanyConfigurtion} from '../../store/CompanyConfiguration/actions';

import GroupTable from './PurchaseTable';
import AccountModal from '../Transactions/accountModal';
const PurchaseNew = (props) => {
  const fp = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [heading, setHeading] = useState(location?.state?.heading);
  document.title = heading + ' - account-books';
  const editRow = location?.state?.editRow;
  const productListResult = useSelector((state) => state.productReducer);
  const purchaseResult = useSelector((state) => state.purchaseReducer);
  const companyConfig = useSelector((state) => state.companyConfiguration.configurationData);
  const accResult = useSelector((state) => state.accounts);

  const [pendingModal, setPendingModal] = useState(false);
  const [modal_invoice, setmodal_invoice] = useState(false);

  const [acc, setAcc] = useState('');

  const [pendingItemList, setPendingItemList] = useState([]);
  const [delList, setDelList] = useState([]);
  const [editList, setEditList] = useState([]);
  const [total, setTotal] = useState(0);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [prodOptions, setProdOptions] = useState([]);
  const [errorMsg, setErrorMsg] = useState({
    groupName: '',
    parent: ''
  });

  const [purchaseInfo, setPurchaseInfo] = useState({
    id: 0,
    date: new Date(),
    supplier: ''
  });
  let defaulVal = {id: 0, product: '', qty: '', rate: 0, amount: '0.000', fix: false, stock: 0};

  const [rows, setRows] = useState([defaulVal]);

  let type = 0;
  if (heading?.includes('Currency')) {
    type = 2.0;
  } else {
    type = 1.0;
  }

  useEffect(() => {
    (async () => {
      fp.current.flatpickr.altInput.focus();
      fp.current.flatpickr.close();
    })();
  }, []);

  let po = productListResult && productListResult?.productList.filter((a) => a.productType == type);
  useEffect(() => {
    if (!prodOptions.length) {
      setProdOptions(po);
      if (!editRow && po.length > 0) {
        handleProduct(po[0], 0);
      }
    }
  }, [productListResult]);

  useEffect(() => {
    if (!editRow && accResult) {
      companyConfig.map((c) => {
        accResult?.accounts?.map((a) => {
          if (c.code == 'PurchaseAccount' && c.value == a.id && heading?.includes('Metal')) {
            setAcc(a);
          }

          if (c.code == 'PurchaseAccountCurr' && c.value == a.id && heading?.includes('Currency')) {
            setAcc(a);
          }
        });
      });
    }
  }, [accResult, companyConfig, heading]);
  useEffect(() => {
    if (editRow) {
      setPurchaseInfo({
        nextPO: editRow.orderNo,
        id: editRow.id,
        date: [new Date(editRow.poDate || editRow.piDate)],
        supplier: {value: editRow?.supplierID, label: editRow.supplierName || editRow.supplier}
      });
      setAcc({value: editRow?.purchaseAccountID, label: editRow.purchaseAccountName});
      let arr = editRow?.productList.map((a) => {
        let obj = {
          product: {value: a.productID, label: a.product || a.productName, id: a.productID},
          qty: a.qty,
          rate: a.rate,
          amount: Number(a.amount).toFixed(3),
          fix: a.isHold,
          stock: a.availStock,
          isEdit: true,
          unit: a?.unitName
        };
        if (a.id || a.id == 0) {
          obj.id = a.id;
        }
        if (a.poid || a.poid == 0) {
          obj.poid = a.poid;
        }
        if (a.piid || a.piid == 0) {
          obj.piid = a.piid;
          obj.prevQty = a.qty;
        }
        if (a.podid || a.podid == 0) {
          obj.podid = a.podid;
        }

        return obj;
      });
      if (heading?.includes('Invoice')) {
        dispatch(getPendingPurchaseItems(editRow?.supplierID, heading));
      }
      let prevDate = moment().subtract(30, 'day');
      let date = [prevDate._d, new Date()];
      dispatch(getPurchaseList(date, editRow?.supplierID, heading));
      setRows(arr);
      var deepCopy1 = JSON.parse(JSON.stringify(arr));
      setEditList(deepCopy1);
      setTotal(Number(editRow.totalAmount));
    } else {
      let url;
      if (heading?.includes('Invoice')) {
        url = 'CompanyConfiguration/GetNextPINo?code=PI_NO';
      } else {
        url = 'CompanyConfiguration/GetNextPONo?code=PO_NO';
      }
      axios.get(url).then((res) => {
        setPurchaseInfo({...purchaseInfo, nextPO: res.value, date: res?.date ? [new Date(res?.date)] : [new Date()]});
      });
    }
  }, [location.state]);
  useEffect(() => {
    setPendingItemList(purchaseResult?.pendingItemList);
  }, [purchaseResult?.pendingItemList]);
  const handleSupplier = (e) => {
    setPurchaseInfo({...purchaseInfo, supplier: e});
    setErrorMsg({...errorMsg, supplier: ''});
    if (heading?.includes('Invoice')) {
      dispatch(getPendingPurchaseItems(e.value, heading));
    }

    let prevDate = moment().subtract(30, 'day');
    let date = [prevDate._d, new Date()];
    dispatch(getPurchaseList(date, e.value, heading));
  };

  useEffect(() => {
    dispatch(getCompanyConfigurtion());
    dispatch(getAccounts());
    dispatch(getProductListActive());
    handleGetSuppliers();
  }, [dispatch]);

  const handleGetSuppliers = () => {
    axios.get('Common/GetSupplierList').then((res) => {
      res.map((a) => {
        a.value = a.id;
        a.label = a.accountName;
      });

      setSupplierOptions(res);
    });
  };

  //-----------------------------------------------------
  const handleAddRow = () => {
    handleProduct(po[0], rows.length, true);
  };

  const handleClear = (e, i) => {
    let obj = [...rows];
    if (obj[i].isEdit) {
      obj[i].operationToPerform = 3;
      setDelList([...delList, obj[i]]);
    }

    obj.splice(i, 1);
    let sum = 0;
    obj &&
      obj.map((data) => {
        sum += Number(data?.amount);
      });
    setTotal(Number(sum.toFixed(3)));
    setRows(obj);
  };

  const handleProduct = (e, i, addRow) => {
    let obj = [];
    if (addRow) {
      obj = [...rows, defaulVal];
    } else {
      obj = [...rows];
    }
    obj[i].newItem = true;
    obj[i].product = {value: e?.productName, label: e?.productName, id: e?.id};
    obj[i].id = 0;
    obj[i].isEdit = false;
    obj[i].stock = e.availStock;
    obj[i].unit = e.units;
    let url = 'Products/GetRateByProductID/' + '?productID=' + e.id;

    editList.map((a, j) => {
      if (j == i && a.isEdit) {
        a.operationToPerform = 3;
        setDelList([...delList, a]);
      }
    });

    if (obj[i].fix) {
      obj[i].amount = 0;
      obj[i].rate = 0;
      setRows(obj);
      handleTotal(obj);
    } else {
      axios.get(url).then((res) => {
        obj[i].rate = res.rate;
        obj[i].amount = (Number(res.rate * obj[i].qty) / 1000).toFixed(3);
        setRows(obj);
        handleTotal(obj);
        setErrorMsg({...errorMsg, row: ''});
      });
    }
  };

  const handleFix = (e, i) => {
    const obj = [...rows];
    obj[i].fix = e.target.checked;
    if (e.target.checked) {
      obj[i].amount = 0;
      obj[i].rate = 0;
      handleTotal(obj);
    }
    setRows(obj);
  };

  const handleBlurQty = (e, i) => {
    const obj = [...rows];
    obj[i].rate = Number(obj[i].rate);
    obj[i].amount = Number(obj[i].amount);
    obj[i].qty = Number(obj[i].qty);
    if ((!obj[i].qty || obj[i].qty == Infinity) && !obj[i].fix) {
      obj[i].qty = 0;
    }
    obj[i].rate1 = false;
    obj[i].amount1 = false;
    handleTotal(obj);
    setRows(obj);
  };

  const handleQty = (e, i) => {
    const obj = [...rows];
    obj[i].rate = Number(obj[i].rate);
    obj[i].amount = Number(obj[i].amount);
    if (!obj[i].rate) {
      obj[i].rate1 = true;
    }
    if (!obj[i].amount) {
      obj[i].amount1 = true;
    }
    let value = e.target.value;
    if (value == '') {
      obj[i].qty = '';
    } else if (obj[i].pendingQty && value <= obj[i].pendingQty && value >= 0) {
      obj[i].qty = value;
    } else if (!obj[i].pendingQty && value >= 0) {
      obj[i].qty = value;
    }
    if (!obj[i].fix) {
      if (!obj[i].rate1 && !obj[i].amount1) {
        obj[i].amount = ((Number(obj[i].qty) * obj[i].rate) / 1000).toFixed(3);
      } else if (obj[i].rate1 && obj[i].amount && Number(obj[i].qty) > 0) {
        obj[i].rate = ((obj[i].amount * 1000) / Number(obj[i].qty))?.toFixed(4);
      } else if (obj[i].amount1 && obj[i].rate) {
        obj[i].amount = ((Number(obj[i].qty) * obj[i].rate) / 1000).toFixed(3);
      }
    }

    setRows(obj);
    handleTotal(obj);
  };
  const handleBlurRate = (e, i) => {
    const obj = [...rows];
    obj[i].rate = Number(obj[i].rate);
    obj[i].amount = Number(obj[i].amount);
    obj[i].qty = Number(obj[i].qty);

    if ((!obj[i].rate || obj[i].rate == Infinity) && !obj[i].fix) {
      obj[i].rate = 0;
    } else if (obj[i].rate.toString().includes('.')) {
      obj[i].rate = (+obj[i].rate)?.toFixed(4);
    }
    obj[i].qty1 = false;
    obj[i].amount1 = false;
    handleTotal(obj);
    setRows(obj);
  };

  const handleRate = (e, i) => {
    const obj = [...rows];
    obj[i].amount = Number(obj[i].amount);
    obj[i].qty = Number(obj[i].qty);

    if (!obj[i].qty) {
      obj[i].qty1 = true;
    }
    if (!obj[i].amount) {
      obj[i].amount1 = true;
    }
    let value = e.target.value;
    if (value == '') {
      obj[i].rate = '';
    } else if (value >= 0) {
      obj[i].rate = value;
    }

    if (!obj[i].fix) {
      if (!obj[i].qty1 && !obj[i].amount1) {
        obj[i].amount = ((obj[i].qty * Number(obj[i].rate)) / 1000).toFixed(3);
      } else if (obj[i].qty1 && obj[i].amount && Number(obj[i].rate) > 0) {
        obj[i].qty = (obj[i].amount * 1000) / Number(obj[i].rate);
      } else if (obj[i].amount1 && obj[i].qty) {
        obj[i].amount = ((obj[i].qty * Number(obj[i].rate)) / 1000).toFixed(3);
      }
    }

    handleTotal(obj);
    setRows(obj);
  };

  const handleBlurAmt = (e, i) => {
    const obj = [...rows];
    obj[i].rate = Number(obj[i].rate);
    obj[i].qty = Number(obj[i].qty);
    if (obj[i].amount?.length <= 3 && !obj[i].fix) {
      obj[i].amount = (obj[i].amount / 1000).toFixed(3);
      if (obj[i].qty > 0) {
        obj[i].rate = ((obj[i].amount * 1000) / obj[i].qty)?.toFixed(4);
      }
    } else {
      if (obj[i].amount.toString().includes('.')) {
        obj[i].amount = (+obj[i]?.amount)?.toFixed(3);
      } else {
        obj[i].amount = (obj[i].amount / 1000).toFixed(3);
        if (obj[i].qty > 0) {
          obj[i].rate = ((obj[i].amount * 1000) / obj[i].qty)?.toFixed(4);
        }
      }
    }
    obj[i].qty1 = false;
    obj[i].rate1 = false;
    setRows(obj);
    handleTotal(obj);
  };
  const handleAmt = (e, i) => {
    const obj = [...rows];
    obj[i].rate = Number(obj[i].rate);
    obj[i].qty = Number(obj[i].qty);

    if (!obj[i].qty) {
      obj[i].qty1 = true;
    }
    if (!obj[i].rate) {
      obj[i].rate1 = true;
    }
    let value = e.target.value;
    if (value == '') {
      obj[i].amount = '';
    } else if (value >= 0) {
      const val = ('' + value).replace('.', '');
      if (val?.length > 3) {
        const suppressedValue = Number(+val / 1000).toFixed(3);
        obj[i].amount = suppressedValue;
      } else {
        obj[i].amount = Number(value);
      }
    }

    if (!obj[i].fix) {
      if (!obj[i].qty1 && !obj[i].rate1 && Number(obj[i].qty) > 0) {
        obj[i].rate = (Number(obj[i].amount) * 1000) / obj[i].qty;
        if (obj[i].rate?.toString()?.length > 7) {
          obj[i].rate = ((Number(obj[i].amount) * 1000) / obj[i].qty)?.toFixed(4);
        } else {
          obj[i].rate = (Number(obj[i].amount) * 1000) / obj[i].qty;
        }

        // obj[i].rate = ((Number(obj[i].amount) * 1000) / obj[i].qty)?.toFixed(4);
      } else if (obj[i].qty1 && obj[i].rate > 0) {
        obj[i].qty = (Number(obj[i].amount) * 1000) / obj[i].rate;
      } else if (obj[i].rate1 && Number(obj[i].qty) > 0) {
        obj[i].rate = (Number(obj[i].amount) * 1000) / obj[i].qty;
        if (obj[i].rate?.toString()?.length > 7) {
          obj[i].rate = ((Number(obj[i].amount) * 1000) / obj[i].qty)?.toFixed(4);
        } else {
          obj[i].rate = (Number(obj[i].amount) * 1000) / obj[i].qty;
        }
        // obj[i].rate = ((Number(obj[i].amount) * 1000) / obj[i].qty)?.toFixed(4);
      }
    }

    setRows(obj);
    handleTotal(obj);
  };

  const handleTotal = (obj) => {
    let sum = 0;
    obj &&
      obj.map((data) => {
        sum += Number(data.amount);
      });

    if (isNaN(sum)) {
      sum = Number(0);
    }

    setTotal(Number(sum.toFixed(3)));
  };

  const handleSave = () => {
    setPurchaseInfo({...purchaseInfo, errShow: true});

    let msg1 = 'Please select account';
    let msg2 = 'Please select supplier';
    if (!acc?.value && !purchaseInfo?.supplier?.value) {
      setErrorMsg({
        account: msg1,
        supplier: msg2
      });
      return;
    }
    if (!acc?.value) {
      setErrorMsg({account: msg1});
      return;
    }
    if (!purchaseInfo?.supplier?.value) {
      setErrorMsg({supplier: msg2});
      return;
    }

    let err = rows.some((a) => !a.product?.id || a.qty <= 0 || !a.qty || a.qty == Infinity);

    if (rows.length != 0 && !err) {
      let date1 = moment(purchaseInfo.date[0]).format('YYYY-MM-DD');
      purchaseInfo.date1 = date1;
      purchaseInfo.account = acc;
      purchaseInfo.total = total;
      dispatch(savePurchase(rows, purchaseInfo, navigate, delList, heading));
      setErrorMsg('	');
    }
  };

  const tog_invoice = () => {
    setmodal_invoice(!modal_invoice);
  };

  const togglePendingModal = () => {
    setPendingModal(!pendingModal);
  };

  const handleSelect = (e, i) => {
    let obj = [...pendingItemList];
    obj[i].isCheck = e.target.checked;
    setPendingItemList(obj);
  };
  const handleSelectAll = (e, i) => {
    let obj = [...pendingItemList];
    if (obj.length != 0) {
      obj.map((a) => {
        if (!a.added) {
          a.isCheck = e.target.checked;
        }
      });
      setPendingItemList(obj);
    }
  };

  const handlePendingClose = () => {
    let arr = [...pendingItemList];
    setPendingModal(false);
    arr.map((a) => {
      a.isCheck = false;
      a.added = false;
    });
    setPendingItemList(arr);
  };
  const htmlTable = () => {
    return (
      <>
        <h5 className='tabView'>Past Orders {purchaseInfo?.supplier.label ? ': ' + purchaseInfo?.supplier.label : ''}</h5>
        {purchaseInfo?.supplier.label ? (
          <GroupTable tableData={purchaseResult?.purchaseList} modTable={true} heading={heading} />
        ) : (
          <div className='text-center mt-5 pt-5'>No Data Available</div>
        )}
      </>
    );
  };
  const handleDate = (e) => {
    let d;
    if (e.length == 0) {
      d = new Date();
    } else {
      d = e;
    }
    setPurchaseInfo({
      ...purchaseInfo,
      date: d
    });
  };

  const handleAddPendingItems = () => {
    let arr1 = pendingItemList.filter((a) => a.isCheck);
    let arr = arr1?.map((a) => {
      return {
        isPull: true,
        podid: a.podid,
        poid: a.poid,
        product: {value: a?.productID, label: a?.productName, id: a?.productID},
        qty: a.penForInvQty,
        pendingQty: a.penForInvQty,
        oldQty: a.poQty,
        rate: a.poRate,
        amount: Number(a.amount)?.toFixed(3),
        fix: a.isHold,
        stock: a?.availStock,
        unit: a?.unitName
      };
    });
    if (arr.length != 0) {
      if (rows.length == 0 || !rows[0].product) {
        setRows(arr);
        handleTotal(arr);
      } else {
        rows.push(...arr);
        handleTotal(rows);
      }
      setPendingModal(false);
    }
  };
  const handlePullData = () => {
    let arr = [...purchaseResult?.pendingItemList];
    if (rows.length != 0) {
      arr.map((a) => {
        rows &&
          rows?.map((b) => {
            if (b?.podid == a?.podid && b?.isPull) {
              a.added = true;
            }
          });
      });
      setPendingItemList(arr);
    } else {
      arr.map((a) => {
        a.added = false;
      });
      setPendingItemList(arr);
    }

    setPendingModal(true);
  };

  return (
    <div className='page-content '>
      <Modal
        isOpen={pendingModal}
        onClosed={() => handlePendingClose()}
        toggle={() => {
          togglePendingModal();
        }}
        centered
        size='lg'
      >
        <ModalHeader
          toggle={() => {
            togglePendingModal();
          }}
        >
          Pending Products for Invoice
        </ModalHeader>
        <ModalBody>
          <table cellPadding={3}>
            <tbody>
              <tr>
                <td className='w90'>
                  <input type='checkbox' onChange={(e) => handleSelectAll(e)} />
                </td>
                <td className='w90'> PNo.</td>
                <td className='w200'>Product</td>
                <td className='w200'> Date</td>
                <td className='w200'>Qty</td>
                <td className='w200'>Rate</td>
                <td className='w200'>Amount</td>
              </tr>

              {pendingItemList &&
                pendingItemList.map((a, i) => {
                  return (
                    <>
                      <tr>
                        <td>
                          <input
                            id='c1'
                            disabled={a?.added ? true : false}
                            type='checkbox'
                            className='cursor'
                            checked={a.isCheck}
                            onChange={(e) => handleSelect(e, i)}
                          />
                        </td>
                        <td>{a.poNumber}</td>
                        <td>{a?.productName}</td>
                        <td>{a?.date} </td>
                        <td>
                          {a.penForInvQty} &nbsp; {a?.unitName}
                        </td>
                        <td>{a.poRate}</td>
                        <td>{Number(a.amount).toFixed(3)}</td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
          {pendingItemList.length == 0 ? <div className='text-center mt-3 pt-3'>No Data Available</div> : <></>}
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={() => setPendingModal(false)}>
            Cancel
          </Button>
          <Button color='primary' onClick={() => handleAddPendingItems()}>
            Add
          </Button>
        </ModalFooter>
      </Modal>
      <div className='row2'>
        <Breadcrumbs breadcrumbItem={editRow ? 'Edit ' + heading : 'New ' + heading} />
        <h5 className='deskView'>Past Orders {purchaseInfo?.supplier.label ? ': ' + purchaseInfo?.supplier.label : ''}</h5>
      </div>

      <Card>
        <CardBody>
          <div className='row1'>
            <div className='wp65' id='leftTable'>
              <Row id='formRow'>
                <Col>
                  <Label>{heading.includes('Invoice') ? 'Invoice' : 'Order'} No.</Label>{' '}
                  <Input disabled={true} value={purchaseInfo?.nextPO} defaultValue={0} />
                </Col>
                <Col>
                  <Label> {heading.includes('Invoice') ? 'Invoice' : 'Order'} Date</Label>
                  <Flatpickr
                    ref={fp}
                    className='form-control'
                    openMenuOnFocus={false}
                    options={{
                      altInput: true,
                      altFormat: 'd/m/Y',
                      disableMobile: true,
                      mode: 'single',
                      dateFormat: 'd/m/Y'
                    }}
                    value={purchaseInfo.date}
                    onChange={(e) => handleDate(e)}
                  />
                </Col>
                <Col>
                  <Label>Supplier</Label>
                  <Select
                    openMenuOnFocus={true}
                    minMenuHeight={400}
                    placeholder='Supplier'
                    options={supplierOptions}
                    defaultValue={purchaseInfo?.supplier}
                    value={supplierOptions ? supplierOptions.find((option) => option.id == purchaseInfo?.supplier?.value) : purchaseInfo?.supplier}
                    onChange={(e) => handleSupplier(e)}
                  />
                  <span className='text-error'> {errorMsg?.supplier}</span>
                </Col>
                <Col>
                  <Label>{heading.includes('Purchase') ? 'Purchase ' : 'Sales '}Account</Label>
                  <Select
                    openMenuOnFocus={true}
                    placeholder='Account'
                    options={accResult?.accounts}
                    value={acc}
                    isDisabled={acc?.value}
                    noOptionsMessage={() => {
                      return (
                        <button className='btn btn-primary btn-block' onClick={() => tog_invoice()}>
                          Add new Account
                        </button>
                      );
                    }}
                    onChange={(e) => {
                      setAcc(e);
                      setErrorMsg({...errorMsg, account: ''});
                    }}
                  />
                  <span className='text-error'> {errorMsg?.account}</span>
                </Col>
                {heading?.includes('Invoice') && purchaseInfo.supplier.value ? (
                  <Col>
                    <Button className='mt30' color={pendingItemList?.length > 0 ? 'primary' : 'secondary'} onClick={() => handlePullData()}>
                      Pull Data
                    </Button>
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
              <br />

              <div>
                <div className='table-responsive react-table table-containerpurchase'>
                  <Table cellPadding={2} border={1}>
                    <thead>
                      <tr>
                        <td>IsUnfix</td>
                        <td>Product</td>
                        <td>Stock</td>
                        <td>Qty</td>
                        <td>Unit</td>
                        <td>Rate</td>
                        <td>Amount</td>
                        <td>Action</td>
                      </tr>
                    </thead>

                    {rows.length > 0 ? (
                      rows.map((a, i) => {
                        return (
                          <>
                            <tbody>
                              <tr>
                                <td className=' text-center align-middle'>
                                  <input type='checkbox' className='cursor' checked={a.fix} onChange={(e) => handleFix(e, i)} />
                                </td>
                                <td>
                                  <Select
                                    openMenuOnFocus={true}
                                    isDisabled={a?.podid ? true : false}
                                    className='w200'
                                    placeholder='Product'
                                    options={prodOptions}
                                    defaultValue={a.product}
                                    value={prodOptions ? prodOptions.find((option) => option.id == a.product?.id) : a.product}
                                    onChange={(e) => handleProduct(e, i)}
                                  />
                                  {/* {purchaseInfo?.errShow && (
                                    <span className='text-error'> {a.product?.id ? '' : 'Please select product'}</span>
                                  )} */}
                                </td>
                                <td>
                                  <Input disabled={true} value={a.stock} />
                                </td>
                                <td>
                                  <Input
                                    type='number'
                                    placeholder='Enter Qty'
                                    disabled={a.product?.id ? false : true}
                                    value={a.qty}
                                    onChange={(e) => handleQty(e, i)}
                                    onBlur={(e) => handleBlurQty(e, i)}
                                  />
                                  {purchaseInfo?.errShow && (a.qty <= 0 || a.qty == Infinity) && (
                                    <span className='text-error'> Please enter Qty</span>
                                  )}
                                </td>
                                <td>
                                  <Input disabled={true} value={a.unit} placeholder='unit' />
                                </td>
                                <td>
                                  <Input
                                    type='number'
                                    disabled={a.fix || !a.product?.id ? true : false}
                                    value={isNaN(a.rate) || a.rate == Infinity ? 0 : a.rate}
                                    onChange={(e) => handleRate(e, i)}
                                    onBlur={(e) => handleBlurRate(e, i)}
                                  />
                                </td>
                                <td>
                                  <Input
                                    type='number'
                                    disabled={!a.product?.id ? true : false}
                                    // value={a.amount}
                                    value={isNaN(a.amount) || a.amount == Infinity ? (0).toFixed(3) : a.amount}
                                    onChange={(e) => handleAmt(e, i)}
                                    onBlur={(e) => handleBlurAmt(e, i)}
                                  />
                                </td>

                                <td className='text-center align-middle'>
                                  <button className='cursor p-0 border-0 bg-transparent text-primary' onClick={(e) => handleClear(e, i)}>
                                    <i className='bx bx-trash-alt text-danger font-size-18 cursor'></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </>
                        );
                      })
                    ) : (
                      <tbody>
                        <tr className='text-center mb-4 mt-4'>
                          <td colSpan={8} className=''>
                            No product added
                          </td>
                        </tr>
                      </tbody>
                    )}

                    <thead>
                      <tr>
                        <td className='cent'>
                          <button className='cursor p-0 border-0 bg-transparent text-primary' onClick={handleAddRow}>
                            <i className='bx bx-plus text-dark bg-light font-size-26 text=bold rounded-circle  cursor'></i>
                          </button>
                        </td>

                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Total:</td>
                        <td>{total?.toFixed(3)}</td>
                        <td></td>
                      </tr>
                    </thead>
                  </Table>
                </div>
                {rows.length == 0 && <div className='text-error'>Please select atleast one row</div>}

                <br />

                <div className='w-100 d-none' id='downTable'>
                  {htmlTable()}
                </div>
                <div>
                  &nbsp;&nbsp;
                  <Button color='secondary' onClick={() => navigate(-1)}>
                    Back
                  </Button>
                  &nbsp;&nbsp;
                  <Button color='primary' onClick={handleSave}>
                    Save
                  </Button>
                </div>
                <div className='whiteBox'></div>
              </div>
            </div>
            <div className='wp35' id='rightTable'>
              {htmlTable()}
            </div>
          </div>
        </CardBody>
      </Card>
      <AccountModal modal_invoice={modal_invoice} tog_invoice={() => tog_invoice()} setmodal_invoice={() => setmodal_invoice()} />
    </div>
  );
};

export default PurchaseNew;
